import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const TEAM_IMG =
    "https://images.unsplash.com/photo-1603201667493-4c2696de0b1f?auto=format&w=1200&q=80";

export default function Team() {
    return (
        <section id="hakkimizda" data-testid="team-bts-section" className="scroll-mt-24 bg-coal py-24 md:py-32">
            <div className="mx-auto grid w-full max-w-[1240px] items-center gap-12 px-6 md:grid-cols-12 md:gap-10 md:px-10">
                <Reveal className="md:col-span-7">
                    <div className="relative">
                        <img
                            src={TEAM_IMG}
                            alt="İçerikleri dizüstü bilgisayarında inceleyen Bi Kadraj Media ekibi"
                            loading="lazy"
                            decoding="async"
                            className="aspect-[4/3] w-full object-cover"
                        />
                        <span className="absolute -bottom-5 right-4 rotate-[-3deg] font-hand text-2xl text-cream/90 md:right-8 md:text-3xl">
                            kamera arkasından
                        </span>
                    </div>
                </Reveal>

                <Reveal delay={0.12} className="md:col-span-5">
                    <Eyebrow>Hakkımızda</Eyebrow>
                    <h2 className="mt-5 font-display text-4xl leading-tight text-cream sm:text-5xl">
                        Perde arkasında gerçek bir ekip var.
                    </h2>
                    <p className="mt-6 text-base leading-relaxed text-fog md:text-lg">
                        Bi Kadraj Media, işletmeler için sosyal medya
                        içeriklerini planlayan, çeken, düzenleyen ve yöneten
                        yaratıcı bir ekip.
                    </p>
                    <p className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-dim">
                        <span>Çekim</span>
                        <span className="h-1 w-1 rounded-full bg-brick" aria-hidden="true" />
                        <span>Kurgu</span>
                        <span className="h-1 w-1 rounded-full bg-brick" aria-hidden="true" />
                        <span>Planlama</span>
                        <span className="h-1 w-1 rounded-full bg-brick" aria-hidden="true" />
                        <span>Yayın</span>
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
